import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import moment from 'moment';
import { Card, CardBody, FormGroup, Label, Button, Input } from 'reactstrap';
import Select from 'react-select';

import TopCaseInfo from '../TopCaseInfo';
import { tripleDotWithEnd } from '../../../../helper/functions';

const statusOptions = [
  { value: 'pending', label: 'Pendiente' },
  { value: 'opened', label: 'Abierto' },
  { value: 'closed', label: 'Cerrado' },
  { value: 're-opened', label: 'Reabierto' },
];

const optionShape = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  label: PropTypes.string,
});

const findIcon = (origin) => {
  const originValue = origin?.value || origin;

  if (originValue === 'phone') {
    return 'phone-handset';
  }
  if (originValue === 'web') {
    return 'laptop';
  }
  if (originValue === 'referred' || originValue === 'face' || originValue === 'trinidad') {
    return 'user';
  }

  return 'user';
};

const CaseStatus = ({ status, commitmentDate, managements }) => {
  if (managements.length && status?.value !== 'closed') {
    return <span className="badge_color_blue badge">En Gestion</span>;
  }

  if (status?.value !== 'closed') {
    return (
      moment().isAfter(commitmentDate)
        ? <span className="badge_color_red badge">Fuera del Plazo</span>
        : <span className="badge_color badge">Dentro del Plazo</span>
    );
  }

  return status?.value === 'closed' && <span className="badge_color_yellow badge">Caso Cerrado</span>;
};

const CaseDetailFormCard = ({
  state,
  type,
  rut,
  managements,
  isAdmin,
  isAuditor,
  disableCreate,
  onSubmitNewCase,
  onStartEdit,
  onDeleteCase,
  onChangeInput,
  typesOptions,
  subtypesOptions,
  disable,
  originOptions,
  canReassign,
  users,
  widthEmailOptions,
  cmfOptions,
  requestGroundsOptions,
  requestGroundsLoading,
  requestClassificationsOptions,
  requestClassificationsLoading,
  initialScoreValue,
  onAttachFile,
  onRemoveAttached,
  onCleanAttached,
  onCancelEdit,
  onClickAssignClient,
  onGoBack,
  onChangeCommitmentDate,
}) => (
  <Card className="cardo_botton" style={{ height: 'auto' }}>
    <CardBody style={{ padding: '0px 10px' }}>
      <form className="form form--horizontal" onSubmit={onSubmitNewCase}>
        <div className="profile_casos profile_casos_detail">
          <div className="crm-top-container">
            <div className="crm-badge-container" style={{ padding: '0px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'flex', width: '80%' }}>
                <div className={`new_lnr lnr-${findIcon(state.origin)} font-case-details`} style={{ height: '40px' }} />
                <div className="head_title_to_case_detail" style={{ flexDirection: 'column', marginLeft: '5%' }}>
                  <h5>{type ? type.label : ''} <span>{!rut && `#${state.code}`}</span></h5>
                  <CaseStatus
                    status={state.status}
                    commitmentDate={state.commitmentDate}
                    managements={managements}
                  />
                </div>
              </div>
            </div>
            <TopCaseInfo values={state} rut={rut} onChangeCommitmentDate={onChangeCommitmentDate} />
            <FormGroup className="crm-edit-buttons">
              {!state.new && !isAuditor && (
                <Fragment>
                  <div className="col-md-3 mt-2">
                    {!state.showButton && (state.status?.value === 'opened' || state.status?.value === 're-opened') && (
                      <button className="crm-details-btn" type="button" onClick={onStartEdit}>
                        <span className="lnr lnr-pencil font-case-details delete_case" />
                      </button>
                    )}
                  </div>
                  {isAdmin && (
                    <div className="col-md-3 mt-4">
                      <button type="button" className="crm-details-btn" onClick={onDeleteCase(state.idDetail)}>
                        <span className="lnr lnr-lnr lnr-trash font-case-details delete_case" />
                      </button>
                    </div>
                  )}
                </Fragment>
              )}
              {state.new && (
                <div className="mt-4">
                  <Button
                    className="asignar just_this"
                    type="submit"
                    id="added"
                    disabled={disableCreate}
                  >
                    Guardar
                  </Button>
                  <Button
                    className="asignar"
                    type="button"
                    id="added"
                    disabled={disableCreate}
                    onClick={onGoBack}
                  >
                    Cancelar
                  </Button>
                </div>
              )}
            </FormGroup>
          </div>
          <div className="compacted col-md-12 crm-case-form-container" style={{ marginBottom: '2%' }}>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="isRedec">Es CMF:</Label>
                <Select
                  options={cmfOptions}
                  name="isRedec"
                  placeholder="seleccione"
                  id="isRedec"
                  isDisabled={state.editField}
                  value={state.isRedec}
                  onChange={onChangeInput('isRedec')}
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="type">Tipo:</Label>
                <Select
                  options={typesOptions}
                  type="text"
                  placeholder="seleccione"
                  name="type"
                  id="type"
                  value={state.type}
                  isDisabled={state.editField}
                  onChange={onChangeInput('type')}
                  required
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="subtype">Tipificación:</Label>
                <Select
                  options={subtypesOptions}
                  type="text"
                  name="subtype"
                  id="subtype"
                  placeholder="seleccione"
                  isLoading={disable}
                  isDisabled={state.editField}
                  value={state.subtype}
                  onChange={onChangeInput('subtype')}
                  required
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="status">Estado:</Label>
                <Select
                  options={statusOptions}
                  type="text"
                  name="status"
                  id="status"
                  isDisabled
                  placeholder="seleccione"
                  value={rut ? statusOptions[1] : state.status}
                  onChange={onChangeInput('status')}
                  required
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="origin">Origen:</Label>
                <Select
                  options={originOptions}
                  type="text"
                  name="origin"
                  placeholder="seleccione"
                  id="origin"
                  isDisabled={state.editField || state.origin?.value === 'web'}
                  value={state.origin}
                  onChange={onChangeInput('origin')}
                  required
                />
              </FormGroup>
            </div>
            {canReassign && (
              <div>
                <FormGroup>
                  <Label className="label_autofin" for="executive">Ejecutivo asignado:</Label>
                  <Select
                    options={users}
                    type="text"
                    name="executive"
                    placeholder="seleccione"
                    id="executive"
                    isDisabled={state.editField}
                    value={state.executive}
                    onChange={onChangeInput('executive')}
                    required
                  />
                </FormGroup>
              </div>
            )}
            <div>
              <FormGroup>
                <Label className="label_autofin" for="with-email">Enviar Correo:</Label>
                <Select
                  options={widthEmailOptions}
                  type="text"
                  name="with-email"
                  placeholder="seleccione"
                  id="with-email"
                  isDisabled={state.editField}
                  value={state.sendEmail}
                  onChange={onChangeInput('sendEmail')}
                  required
                />
              </FormGroup>
            </div>
            <div>
              <FormGroup>
                <Label className="label_autofin" for="score">Calificacion de respuesta:</Label>
                <Select
                  options={[initialScoreValue, ...state.scoreOptions]}
                  name="score"
                  placeholder="Seleccione"
                  id="score"
                  isDisabled={state.editField || type?.label?.toLowerCase() === 'consulta'}
                  value={state.score || ''}
                  onChange={onChangeInput('score')}
                  required
                />
              </FormGroup>
            </div>
            {state?.isRedec?.value && <div>
              <FormGroup>
                <Label className="label_autofin" for="requestGrounds">Fundamento de la solicitud:</Label>
                <Select
                  options={requestGroundsOptions}
                  name="requestGrounds"
                  placeholder="seleccione"
                  id="requestGrounds"
                  isDisabled={state.editField}
                  isLoading={requestGroundsLoading}
                  value={state.requestGrounds}
                  onChange={onChangeInput('requestGrounds')}
                />
              </FormGroup>
            </div>}
            {state?.isRedec?.value && <div>
              <FormGroup>
                <Label className="label_autofin" for="requestClassifications">Clasificación de solicitud:</Label>
                <Select
                  options={requestClassificationsOptions}
                  name="requestClassifications"
                  placeholder="seleccione"
                  id="requestClassifications"
                  isDisabled={state.editField}
                  isLoading={requestClassificationsLoading}
                  value={state.requestClassifications}
                  onChange={onChangeInput('requestClassifications')}
                />
              </FormGroup>
            </div>}
            {!isAuditor && (
              <div>
                <FormGroup className="crm-add-doc-group">
                  <div className="field">
                    {state.documenttoS3.length >= 2 && <Label className="label_autofin" htmlFor="type">Adjuntar archivo {` (${state.documenttoS3.length} seleccionados)`}</Label>}
                    {state.documenttoS3.length < 2 && <Label className="label_autofin" htmlFor="type">Adjuntar archivo (Maximo 5)</Label>}
                    <div className="file-field">
                      <div className="file-group">
                        <input
                          id="attach-file-crm"
                          type="file"
                          name="files"
                          disabled={state.editField}
                          onChange={onAttachFile}
                          multiple
                        />
                        <label
                          className={state.editField ? 'attatch-label-disabled' : 'attatch-label'}
                          htmlFor="attach-file-crm"
                        >
                          Subir Archivo
                        </label>
                      </div>
                      {state.documenttoS3.length >= 1 && (
                        <div className="file-all-files">
                          <div className="file-file-list">
                            {map(state.documenttoS3, (file) => (
                              <button
                                key={file.name}
                                className="file-remove-btn"
                                type="button"
                                onClick={() => onRemoveAttached(file.name)}
                                onMouseEnter={(e) => e.currentTarget.classList.add('hovered')}
                                onMouseLeave={(e) => e.currentTarget.classList.remove('hovered')}
                              >
                                {tripleDotWithEnd(file.name, 30)}
                                <span className="remove-text">X</span>
                              </button>
                            ))}
                          </div>
                          {state.documenttoS3.length >= 3 && (
                            <button className="file-removeall-btn" type="button" onClick={onCleanAttached}>
                              Quitar Todos
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
            )}
            <div>
              <FormGroup>
                <Label className="label_autofin" for="description">Descripcion:</Label>
                <Input
                  type="textarea"
                  className="newArea"
                  name="description"
                  id="description"
                  style={{ height: '64px' }}
                  maxLength="300"
                  disabled={state.editField}
                  value={state.description}
                  onChange={onChangeInput('description')}
                />
              </FormGroup>
            </div>
          </div>
        </div>
        <div className="crm-button-form">
          {state.showButton && (
            <div className="crm-save-btn-container">
              <button type="button" className="crm-cancel-btn" onClick={onCancelEdit}>Cancelar</button>{' '}
              <button
                className="crm-save-btn"
                type="submit"
                id="added"
              >
                Guardar
              </button>
            </div>
          )}
          {!state.showButton && state.clientEmail && !state.flatForClient && (
            <div className="crm-assign-btn-container">
              <button
                type="button"
                onClick={onClickAssignClient}
              >
                Asignar cliente
              </button>
            </div>
          )}
        </div>
      </form>
    </CardBody>
  </Card>
);

CaseStatus.propTypes = {
  status: optionShape,
  commitmentDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  managements: PropTypes.arrayOf(PropTypes.object),
};

CaseStatus.defaultProps = {
  status: null,
  commitmentDate: null,
  managements: [],
};

CaseDetailFormCard.propTypes = {
  state: PropTypes.shape({
    origin: optionShape,
    status: optionShape,
    type: optionShape,
    subtype: optionShape,
    sendEmail: optionShape,
    isRedec: optionShape,
    requestGrounds: optionShape,
    requestClassifications: optionShape,
    score: optionShape,
    executive: optionShape,
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    new: PropTypes.bool,
    showButton: PropTypes.bool,
    editField: PropTypes.bool,
    idDetail: PropTypes.string,
    documenttoS3: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
    scoreOptions: PropTypes.arrayOf(optionShape),
    description: PropTypes.string,
    clientEmail: PropTypes.string,
    flatForClient: PropTypes.bool,
    commitmentDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }).isRequired,
  type: optionShape,
  rut: PropTypes.string,
  managements: PropTypes.arrayOf(PropTypes.object),
  isAdmin: PropTypes.bool.isRequired,
  isAuditor: PropTypes.bool.isRequired,
  disableCreate: PropTypes.bool,
  onSubmitNewCase: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onDeleteCase: PropTypes.func.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  typesOptions: PropTypes.arrayOf(optionShape),
  subtypesOptions: PropTypes.arrayOf(optionShape),
  disable: PropTypes.bool,
  originOptions: PropTypes.arrayOf(optionShape),
  canReassign: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(optionShape),
  widthEmailOptions: PropTypes.arrayOf(optionShape),
  cmfOptions: PropTypes.arrayOf(optionShape),
  requestGroundsOptions: PropTypes.arrayOf(optionShape),
  requestGroundsLoading: PropTypes.bool,
  requestClassificationsOptions: PropTypes.arrayOf(optionShape),
  requestClassificationsLoading: PropTypes.bool,
  initialScoreValue: optionShape.isRequired,
  onAttachFile: PropTypes.func.isRequired,
  onRemoveAttached: PropTypes.func.isRequired,
  onCleanAttached: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onClickAssignClient: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
  onChangeCommitmentDate: PropTypes.func.isRequired,
};

CaseDetailFormCard.defaultProps = {
  type: null,
  rut: '',
  managements: [],
  disableCreate: false,
  typesOptions: [],
  subtypesOptions: [],
  disable: false,
  originOptions: [],
  users: [],
  widthEmailOptions: [],
  cmfOptions: [],
  requestGroundsOptions: [],
  requestGroundsLoading: false,
  requestClassificationsOptions: [],
  requestClassificationsLoading: false,
};

export default CaseDetailFormCard;
